export default {
  path: "/app/contract",
  redirect: "/app/contract",
  component: () => import("../layout"),
  children: [
    {
      name: "myListContract",
      path: "/app/contract",
      component: () => import("../ContractList.vue"),
      meta: {
        appName: "myListContract",
      },
    },
    {
      name: "listContractCanEdit",
      path: "/app/contract-can-edit",
      component: () => import("../contract-can-edit.list.vue"),
      meta: {
        appName: "listContractCanEdit",
      },
    },
    {
      path: "/app/contract/:idContract/edit",
      name: "editContract",
      component: () => import("../ContractEdit.vue"),
    },
    {
      path: "/app/contract/:idContract/view",
      name: "viewContract",
      component: () => import("../ContractView.vue"),
    },
    {
      path: "/app/contract/:idContract/view-dev",
      name: "ContractViewDev",
      component: () => import("../ContractViewDev.vue"),
    },
    {
      path: "/app/contract/bu",
      name: "contractBU",
      component: () => import("../childApp/contractBU"),
      meta: {
        appName: "contractBU",
      },
    },
    {
      path: "/app/contract/entity",
      name: "contractEntity",
      component: () => import("../childApp/contractEntity"),
      meta: {
        appName: "contractEntity",
      },
    },
    {
      path: "/app/contract/dealer-code",
      name: "contractEntityDealerCode",
      component: () => import("../childApp/contractEntityDealerCode"),
      meta: {
        appName: "contractEntityDealerCode",
      },
    },
    {
      path: "/app/contract/country",
      name: "country",
      component: () => import("../childApp/country"),
      meta: {
        appName: "country",
      },
    },
    {
      path: "/app/contract/contract-port",
      name: "contractPort",
      component: () => import("../childApp/contractPort"),
      meta: {
        appName: "contractPort",
      },
    },
    {
      path: "/app/contract/product",
      name: "contractProduct",
      component: () => import("../childApp/contractProduct"),
      meta: {
        appName: "contractProduct",
      },
    },
    {
      path: "/app/contract/product-type",
      name: "contractProductType",
      component: () => import("../childApp/contractTypeProduct"),
      meta: {
        appName: "contractProductType",
      },
    },
    {
      path: "/app/contract/contractForm",
      name: "contractForm",
      component: () => import("../childApp/contractForm"),
      meta: {
        appName: "contractForm",
      },
    },
    {
      path: "/app/contract/customer",
      name: "customer",
      component: () => import("../childApp/customer"),
      meta: {
        appName: "customer",
      },
    },
    {
      path: "/app/contract/supplier",
      name: "supplier",
      component: () => import("../childApp/contractSupplier"),
      meta: {
        appName: "supplier",
      },
    },
    {
      path: "/app/contract/end-user",
      name: "endUser",
      component: () => import("../childApp/endUser"),
      meta: {
        appName: "endUser",
      },
    },
    {
      path: "/app/contract/inventory/import",
      name: "contractInventoryImport",
      component: () => import("../childApp/contractInventoryImportExcel"),
      meta: {
        appName: "contractInventoryImport",
      },
    },
    {
      path: "/app/contract/inventory/import/update",
      name: "contractInventoryUpdateImport",
      component: () => import("../childApp/contractInventoryImportUpdateExcel"),
      meta: {
        appName: "contractInventoryUpdateImport",
      },
    },
    {
      path: "/app/contract/inventory",
      name: "contractInventory",
      component: () => import("../childApp/contractEquipmentNoInvoice"),
      meta: {
        appName: "contractInventory",
      },
    },
    {
      path: "/app/contract/inventory/edit-multiple",
      name: "editMultiple",
      component: () =>
        import(
          "../childApp/contractEquipmentNoInvoice/components/EditMultiple"
        ),
      meta: {
        appName: "editMultiple",
      },
    },
    {
      path: "/app/contract/contract-status",
      name: "contractStatus",
      component: () => import("../childApp/contractStatus"),
      meta: {
        appName: "contractStatus",
      },
    },
    {
      path: "/app/contract/contract-equipment-code",
      name: "contractEquipmentCode",
      component: () => import("../childApp/contractEquipmentCode"),
      meta: {
        appName: "contractEquipmentCode",
      },
    },
    {
      path: "/app/contract/contract-bu-segment-code",
      name: "contractSegmentCodeBU",
      component: () => import("../childApp/contractSegmentCodeBU"),
      meta: {
        appName: "contractSegmentCodeBU",
      },
    },
    {
      path: "/app/contract/contract-location",
      name: "contractLocation",
      component: () => import("../childApp/contractLocation"),
      meta: {
        appName: "contractLocation",
      },
    },
    {
      path: "/app/contract/contract-notification",
      name: "contractNotification",
      component: () => import("../childApp/contractNotification"),
      meta: {
        appName: "contractNotification",
      },
    },

    {
      path: "/app/contract/contract-location",
      name: "contractLocation",
      component: () => import("../childApp/contractLocation"),
      meta: {
        appName: "contractLocation",
      },
    },
    {
      path: "/app/contract/dealer-code-buyer",
      name: "contractDealerCodeBuyer",
      component: () => import("../childApp/contractDealerCodeBuyer"),
      meta: {
        appName: "contractDealerCodeBuyer",
      },
    },
    {
      path: "/app/contract/full-control-permission",
      name: "permissionFullControl",
      component: () => import("../childApp/permissionFullControl"),
      meta: {
        appName: "permissionFullControl",
      },
    },
    // APPROVAL
    {
      name: "myApprovalWaitingContract",
      path: "/app/contract/my-approval-waiting",
      component: () => import("../MyApprovalWaitingContract.vue"),
      meta: {
        appName: "myApprovalWaitingContract",
      },
    },
    {
      name: "myApprovalDoneContract",
      path: "/app/contract/my-approval-done",
      component: () => import("../MyApprovalDoneContract.vue"),
      meta: {
        appName: "myApprovalDoneContract",
      },
    },
    //ANNEXES APRROVAL
    {
      name: "contractAnnexesList",
      path: "/app/contract/annexes",
      component: () => import("../ContractAnnexesList.vue"),
      meta: {
        appName: "contractAnnexesList",
      },
    },
    {
      name: "myApprovalWaitingContractAnnexes",
      path: "/app/contract/my-annexes-approval-waiting",
      component: () => import("../MyApprovalWaitingContractAnnexes.vue"),
      meta: {
        appName: "myApprovalWaitingContractAnnexes",
      },
    },
    {
      name: "myApprovalDoneContractAnnexes",
      path: "/app/contract/my-annexes-approval-done",
      component: () => import("../MyApprovalDoneContractAnnexes.vue"),
      meta: {
        appName: "myApprovalDoneContractAnnexes",
      },
    },
    // BI REPORT
    {
      name: "bIReport",
      path: "/app/contract/bi-report",
      component: () => import("../BiReport.vue"),
      meta: {
        appName: "bIReport",
      },
    },
    // REPORT
    {
      name: "reportHasEngineSTU",
      path: "/app/contract/report-has-engine-stu",
      component: () => import("../childApp/reportSTU"),
      meta: {
        appName: "reportHasEngineSTU",
      },
      props: {
        readOnly: true,
      },
    },
    {
      name: "reportContractLog",
      path: "/app/contract/report-contract-log",
      component: () => import("../childApp/contractLogNewV1"),
      meta: {
        appName: "reportContractLog",
      },
    },
    {
      name: "reportContractLogNew",
      path: "/app/contract/report-contract-log-new",
      component: () => import("../childApp/contractLogNewV1"),
      meta: {
        appName: "reportContractLogNew",
      },
    },
    {
      name: "reportContractOutstandingDeliveryPenalty",
      path: "/app/contract/report-contract-outstanding-delivery-penalty",
      component: () => import("../childApp/contractOutstandingDeliveryPenalty"),
      meta: {
        appName: "reportContractOutstandingDeliveryPenalty",
      },
    },
    {
      name: "totalMachineList",
      path: "/app/contract/report-total-machine",
      component: () => import("../childApp/totalMachineList"),
      meta: {
        appName: "totalMachineList",
      },
    },
    {
      name: "insuranceReport",
      path: "/app/contract/report-insurance",
      component: () => import("../childApp/insuranceReport"),
      meta: {
        appName: "insuranceReport",
      },
    },
    {
      name: "reportAgedInventory",
      path: "/app/contract/report-aged-inventory",
      component: () => import("../childApp/reportAgedInventory"),
      meta: {
        appName: "reportAgedInventory",
      },
    },
    {
      name: "reportSaleperson",
      path: "/app/contract/report-saleperson",
      component: () => import("../childApp/reportSaleperson"),
      meta: {
        appName: "reportSaleperson",
      },
    },
    {
      name: "reportSaleRecord",
      path: "/app/contract/report-sale-record",
      component: () => import("../childApp/reportSaleRecord"),
      meta: {
        appName: "reportSaleRecord",
      },
    },
    {
      name: "reportSTURecord",
      path: "/app/contract/report-stu-record",
      component: () => import("../childApp/reportSTURecord"),
      meta: {
        appName: "reportSTURecord",
      },
    },
    //  FREIGTH REQUEST AND DELIVERY ORDER
    {
      name: "freightRequestAndDeliveryOrder",
      path: "/app/contract/freight-request-and-delivery-order",
      component: () =>
        import("../childApp/freightRequestAndDeliveryOrder/list-item"),
      meta: {
        appName: "freightRequestAndDeliveryOrder",
      },
    },
    {
      name: "freightRequestAndDeliveryOrderDetail",
      path: "/app/contract/freight-request-and-delivery-order/:id/detail",
      component: () =>
        import("../childApp/freightRequestAndDeliveryOrder/detail-item"),
      meta: {
        appName: "freightRequestAndDeliveryOrderDetail",
      },
    },
    {
      name: "freightRequestAndGoodReceivingNote",
      path: "/app/contract/freight-request-and-good-receiving-note",
      component: () =>
        import("../childApp/freightRequestAndGoodReceivingNote/list-item"),
      meta: {
        appName: "freightRequestAndGoodReceivingNote",
      },
    },
    {
      name: "freightRequestAndGoodReceivingNoteDetail",
      path: "/app/contract/freight-request-and-good-receiving-note/:id/detail",
      component: () =>
        import("../childApp/freightRequestAndGoodReceivingNote/detail-item"),
      meta: {
        appName: "freightRequestAndGoodReceivingNoteDetail",
      },
    },
    {
      name: "jobRequestList",
      path: "/app/contract/job-request",
      component: () => import("../childApp/jobRequest/list-item"),
      meta: {
        appName: "jobRequestList",
      },
    },
    {
      name: "jobRequestDetail",
      path: "/app/contract/job-request/:id/detail",
      component: () => import("../childApp/jobRequest/detail-item"),
      meta: {
        appName: "jobRequestDetail",
      },
    },
    {
      name: "warehouse",
      path: "/app/contract/warehouse",
      component: () => import("../childApp/warehouse"),
      meta: {
        appName: "warehouse",
      },
    },
    {
      name: "contractFormRequestCompany",
      path: "/app/contract/form-request-company",
      component: () => import("../childApp/contractFormRequestCompany"),
      meta: {
        appName: "contractFormRequestCompany",
      },
    },
    {
      name: "deliveryCode",
      path: "/app/contract/delivery-code",
      component: () => import("../childApp/deliveryCode"),
      meta: {
        appName: "deliveryCode",
      },
    },
    {
      name: "pdf",
      path: "/app/contract/pdf",
      component: () => import("../childApp/pdfLib"),
      meta: {
        appName: "pdf",
      },
    },
    {
      name: "saleAdminUpload",
      path: "/app/contract/sale-admin-upload",
      component: () => import("../sale-admin-upload"),
      meta: {
        appName: "saleAdminUpload",
      },
    },
  ],
};
